import React from 'react';
import Main from './components/Main'
import { StoreProvider } from "./components/Utility/Store";

function App() {
  return (
    <StoreProvider>
      <Main />
    </StoreProvider>
  );
}

export default App;
